import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { ValuesMap } from '@/common/types';
import { API_URL } from '@/dtos';

interface Response {
  id_summary_result: string;
}

export default () => {
  const { mutateAsync, isLoading } = useMutation(
    (data: { values: ValuesMap<string | number>; isChallengeMode?: boolean }) =>
      api.post<Response>(
        data?.isChallengeMode ? API_URL.IDOLOGY_CHALLENGE_ANSWERS : API_URL.IDOLOGY_QUESTIONNAIRE_ANSWERS,
        data.values
      )
  );

  return {
    save: mutateAsync,
    isLoading,
  };
};
